<style>
.snackbar-button{
    width: 200px;
    border: 1px solid;
    border-image: linear-gradient(to left, #6bbc56, #6bbc56 25%, #2fa9d8 75%),1;
    border-radius: 5px;
    background-image: linear-gradient(to left, #6bbc56, #6bbc56 25%, #2fa9d8 75%);
    color: white;
    font-size: 20px;
    font-weight: normal;
    padding: 5px;
  }
  .snackbar-title{
    width: 300px;
    border: none;
    border-radius: 20px 20px 0px 0px;
    background-image: linear-gradient(to left, #6bbc56, #6bbc56 25%, #2fa9d8 75%);
    color: white;
    font-size: 22px;
    font-weight: normal;
    padding: 5px 15px 5px 15px;
    margin-bottom: 5px;
  }
  .snackbar-image{
    width: 300px;
    border: none;
    height: 100px;
    width: 350px;
  }
  .snackbar-content{
    width: 300px;
    border: none;
    border-radius: 0px 0px 20px 20px;
    background-image: linear-gradient(to left, #6bbc56, #6bbc56 25%, #2fa9d8 75%);
    color: white;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    padding: 5px 15px 5px 15px;
  }
</style>

<template>
  <v-container>
    <v-layout row wrap justify-center>
    <div style="min-width:100%">
      <v-flex>
        <v-card class="text-xs-center" style="min-width:100%">
          <v-img :src="require('@/assets/bannerImage.png')" class="img-fluid"></v-img>
          <span class="quates">
            {{ quates }}
            <div class="mt-3 underline"></div>
          </span>
        </v-card>
      </v-flex>

      <v-flex mt-7>
        <v-card flat height="100%" style="text-align: center">
          <span class="quoteTitle">
            <span>{{ Title }}</span>
          </span>
          <v-card v-for="item in content" :key="item.text" flat class="content">
            <span class="listItem">
              <v-icon size="7px" v-text="item.icon"></v-icon> &nbsp;{{
                item.text
              }}
            </span>
          </v-card>
          <v-col>
            <v-btn
              id="registerbtn"
              v-if="!isLoggedin"
              class="mt-4 btn btn-1 text-capitalize"
              router
              :to="'/Registration'"
            >
              REGISTER
            </v-btn>
            <br>
            <!-- <div class="float-end" v-if="value" v-show="value">
              <div>
                <h2 class="snackbar-title">
                  WEBINAR <button class="float-end mr-1" @click="value=false">X</button>
                </h2>
              </div>
              <div class="snackbar-image">
                <v-img src="../assets/cover2.png" width="300px"></v-img>
              </div>
              <div class="snackbar-content">
                <ul>
                  <li>A basic foundation in the Value of Distributed Energy Resource Methodology(VODER).</li>
                  <li>A basic foundation in the Value of Distributed Energy Resource Methodology(VODER).</li>
                  <li>Introduction and access to a free online tool to undertake a VODER analysis.</li>
                  <li>Access to a shared pool or load profiles and data resources.</li>
                </ul>
                <div class="mx-auto" style="text-align: center;">
                  <button style="height: 23px; width: 80px; background-color: white; border:2px solid #2fa9d8;  border-radius: 5px; box-shadow: 1px 2px 2px rgb(24, 164, 224);">
                    <a id="register_button" style="color: #2fa9d8; text-decoration: none; font-size: 14px; font-weight: 600;" target="blank" href="https://us06web.zoom.us/meeting/register/tZIucuuprTouHdMp6EzC3A27H7tftkHFa0Gk?workshop_title=Solva+Webinar%3A+Evaluating+the+value+of+distributed+generation&workshopID=5114&workshop_date_selector=24%2F08%2F2023&workshop_fees_selector=0.0#/registration
">REGISTER</a>
                  </button>
                </div>
              </div>
            </div>
            <div v-else><button class="snackbar-button float-end" @click="value=true">WEBINAR</button></div> -->
          </v-col>
        </v-card>
      </v-flex>
      
      </div>
    </v-layout>
    
  </v-container>
  
</template>

<script>
import settingsUtility from "@/utility/settingsUtility";

export default{
  name: "Home",
  metaInfo() {
    return{
      title: "Solva - Home",
      meta:[
        { property:'og:title', content: "Solva" },
        { property: "og:description", content: `Evaluate the value of distributed solar and storage` },
        { property: 'og:image', itemprop: "image", content: `https://solva.in/img/Solva_Logo.6b5b1270.svg` },
        { property: "og:image:type" ,content: "image/png" },
        { property: "og:image:width" ,content: "300" },
        { property: "og:image:height" ,content: "300" },
        { property: "og:url", content: "https://solva.in/" }
      ]
    };
  },
  mounted() {
    this.isLoggedin = settingsUtility.methods.getLoginStatus();
  },
  data: () => ({
    isLoggedin: false,
    quates:
      "Evaluate the value of distributed solar and storage",
    Title: "The Solva web tool allows users to",
    content: [
      {
        icon: "mdi-checkbox-blank-circle",
        text: "Undertake a feeder level power flow analysis for distributed solar and energy storage.",
      },
      {
        icon: "mdi-checkbox-blank-circle",
        text: "Evaluate the netwok system benefits and the social and environmental benefits for distributed solar and energy storage.",
      },
      {
        icon: "mdi-checkbox-blank-circle",
        text: "Identify system sizes and distpatch strategies to optimize the value of distributed solar and energy storage.",
      },
    ],
    src: "@/assets/solarpannel.png",
    value: true,
  }),
};
</script>
<style scoped>
.container {
  max-width: 100%;
}
.quates {
  font-size: 35px;
  font-weight: 300;
  color: #eee;
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  text-align: center;
  line-height: 45px;
}
.quoteTitle {
  font-size: 20px;
  font-weight: 600;
  color: #397c3d;
}
.listItem {
  font-size: 17px;
  font-weight: 400;
  color: #5d5e5e;
  line-height: 18.05pt;
}
.content {
  padding-top: 2px;
}
.btn {
  font-size: 20px;
  font-weight: normal;
  width: 45px;
  height: 28px;
  flex: 1 1 auto;
  padding: 30px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  border-radius: 4px;
}
.btn-1 {
  background-image: linear-gradient(
    to right,
    #6bbc56 0%,
    #2fa9d8 55%,
    #2fa9d8 100%
  );
}

.underline {
  margin: auto;
  width: 120px;
  min-width: 1px;
  height: 2px;
  background-image: linear-gradient(
    to right,
    #6bbc56 0%,
    #2fa9d8 55%,
    #2fa9d8 100%
  );
}
.v-btn:not(.v-btn--round).v-size--default {
  font-size: 22px;
  font-weight: normal;
  width: 190px;
  height: 28pt;
}
</style>